<div class="row">

  <div class="col-md-12">
    <div class="row">
      <div class="col-md-12 mb-2">
        <h2>Application details</h2>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <div class="form-group">
          <label>Applicant number</label>
          <div type="text" class="form-control readonly" [innerHTML]="$safeNavigationMigration(application?.applicantDetails?.registrationNumber)"></div>
        </div>
      </div>

      <div class="col-md-4">
        <div class="form-group">
          <label>Applicant name</label>
          <div type="text" name="reg" class="form-control readonly" [innerHTML]='name'></div>
        </div>
      </div>

      <div class="col-md-4">
        <div class="form-group">
          <label>Date Submitted</label>
          <div type="text" class="form-control readonly" [innerHTML]="application?.form?.dateApplicationSubmitted ? ( application.form.dateApplicationSubmitted | date:'dd/MM/yyyy') : '-'"></div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-md-12">
    <div class="row">
      <div class="col-md-12 mb-2">
        <h2>Removal details</h2>
      </div>
    </div>
  </div>

  <div class="col-md-12">
    <div class="row">

      <div class="col-md-6">
        <div class="form-group">
          <label for="removalDateChosen">What date would you like to be removed from the register?</label>
          <div style="min-height: 40px;" class="form-control readonly" [innerHTML]="$safeNavigationMigration(voluntaryRemovalDetails?.dateOfRegistryRemoval) | utcDate"></div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-md-12">
    <div class="row">

      <div class="col-md-6">
        <div class="form-group">
          <label for="reasonForRemoval">Please tell us why you want to have your entry removed from the register.</label>
          <div style="min-height: 40px;" class="form-control readonly"
            [innerHTML]="$safeNavigationMigration(voluntaryRemovalDetails?.reasonForRemoval)">
          </div>
        </div>
      </div>

      @if (voluntaryRemovalDetails?.reasonForRemoval === 'Health' || voluntaryRemovalDetails?.reasonForRemoval === 'Other') {
        <div class="col-md-6">
          <div class="form-group">
            <label for="details">Please provide a short explanation</label>
            <div style="min-height: 40px;" class="form-control readonly"
              [innerHTML]="$safeNavigationMigration(voluntaryRemovalDetails?.reasonForRemovalDetails)">
            </div>
          </div>
        </div>
      }
    </div>
  </div>

  @if (isUserSI) {
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-12 mb-2">
          <h2>Superintendent</h2>
        </div>
      </div>
    </div>
  }

  @if (isUserSI) {
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label for="ownerName">Owner name</label>
            <div style="min-height: 40px;" class="form-control readonly"
              [innerHTML]="$safeNavigationMigration(application?.ownerName)">
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="ownerNumber">Owner number</label>
            <div style="min-height: 40px;" class="form-control readonly"
              [innerHTML]="$safeNavigationMigration(application?.ownerNumber)">
            </div>
          </div>
        </div>
      </div>
    </div>
  }

  <div class="col-md-12">
    <app-application-ftp [application]="application" [applicationType]="'vr'"></app-application-ftp>
  </div>

  <div class="col-md-12">
    <div class="row">
      <div class="col-md-12 mb-2">
        <h2>Application declarations</h2>
      </div>
    </div>
  </div>

  <div class="col-md-12">
    <div class="row">

      <div class="col-md-12">
        <div class="form-group">
          <label for="declaration1">I declare that I am applying for voluntary removal  from the register.
          The information I have provided for this application is complete, true and accurate. </label>
          <div style="min-height: 40px;" class="form-control readonly"
            [innerHTML]="appDeclaration.isQ1Confirmed ? 'Yes' : '-'">
          </div>
        </div>
      </div>

      @if ((getObjectLength(FtPAnswers) > 0) && !FtPAnswers.Yes) {
        <div class="col-md-12">
          <div class="form-group">
            <label for="isAllNoToFtpDeclarartions">I have answered 'no' to all of the declarations of fitness to practise and
              I am not aware of any action that I taken, or have not taken, which would be likely to result in an allegation
            that my fitness to practise is impaired.</label>
            <div style="min-height: 40px;" class="form-control readonly"
              [innerHTML]="appDeclaration.isQ2Confirmed ? 'Yes' : '-'">
            </div>
          </div>
        </div>
      }

      @if ((getObjectLength(FtPAnswers) > 0 && FtPAnswers.Yes) && (getObjectLength(FtPSubAnswers) > 0 && !FtPSubAnswers.No)) {
        <div class="col-md-12">
          <div class="form-group">
            <label for="isYesToAnyFtpDeclarartionsAndNotified">
              I have answered 'yes' to one or more of the declarations of fitness to practise and have previously
              notified the GPhC or RPS of this by filling in a something to declare form.  I am not aware of any
              action that I have taken, or have not taken, which would be likely to result in an allegation that
              my fitness to practise is impaired.  If it is relevant to my application, I request that the registrar
              considers my application for voluntary removal from the register in accordance with Rule 14(6)(b) of the
              GPhC Registration Rules 2010.
            </label>
            <div style="min-height: 40px;" class="form-control readonly"
              [innerHTML]="appDeclaration.isQ2Confirmed ? 'Yes' : '-'">
            </div>
          </div>
        </div>
      }

      @if ((getObjectLength(FtPAnswers) > 0 && FtPAnswers.Yes) && (getObjectLength(FtPSubAnswers) > 0 && FtPSubAnswers.No)) {
        <div class="col-md-12">
          <div class="form-group">
            <label for="isYesToAnyFtpDeclarartionsAndNotNotified">
              I have answered 'yes' to one or more of the declarations of fitness to practise and am aware that
              I must provide more information about this to the GPhC, by submitting a something to declare form
              within seven days of submitting this application.  I am not aware of any action that I have taken,
              or have not taken, which would be likely to result in an allegation that my fitness to practise is
              impaired.  If it is relevant to my application, I request that the registrar considers my application
              for voluntary removal from the register in accordance with Rule 14(6)(b) of the GPhC Registration Rules 2010.
            </label>
            <div style="min-height: 40px;" class="form-control readonly"
              [innerHTML]="appDeclaration.isQ2Confirmed ? 'Yes' : '-'">
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</div>